import React from 'react';
import Heading from '../../components/Heading';
import PropertiesTable from '../../components/PropertiesTable';
import Tabs from '../../components/Tabs';
import { variables } from 'src/Tenants';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';
import {
  usePropertiesPageOrchestrator,
  UsePropertiesPageOrchestratorReturn,
} from './CustomHooks/usePropertiesPageOrchestrator';

const Properties: React.FC = () => {
  const {
    properties,
    isLoadingProperties,
    tabList,
    totalSuites,
    totalServiceRequests,
    saveProperty,
    deleteProperty,
    searchProperties,
    applyWalkthroughSyncState,
    clearModulePermissionSelection,
  }: UsePropertiesPageOrchestratorReturn = usePropertiesPageOrchestrator();

  return (
    <WithNavigation
      title="Properties"
      top={
        <Heading
          headline="Properties"
          loading={isLoadingProperties}
          items={[
            {
              key: 'Properties',
              value: properties.length,
            },
            {
              key: variables.suites,
              value: totalSuites,
            },
            {
              key: 'Service Requests',
              value: totalServiceRequests,
            },
          ]}
        />
      }
      bottom={
        <Tabs
          items={[
            {
              label: 'Properties',
              length: properties.length,
              content: (
                <PropertiesTable
                  properties={properties}
                  isLoadingProperties={isLoadingProperties}
                  onSaveProperty={saveProperty}
                  onSearch={(e: any) =>
                    searchProperties(e.target.value.trim())
                  }
                  onDeleteProperty={deleteProperty}
                  tabList={tabList}
                  clearSelectedModulePermission={clearModulePermissionSelection}
                  onWalkthroughSyncToggle={applyWalkthroughSyncState}
                />
              ),
            },
          ]}
        />
      }
    />
  );
};

export default Properties;